module.exports = __webpack_public_path__ + "static/media/16CO202.de24dc2d.jpeg";